import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";

import { ProgressiveImage, Icon } from "components";
import { selectFocusedVideos, getButtonBgColor, setFocusedVideoIdx, getSelectedBadgeVideo, selectFocusedVideo, getSelectedBadgeVideoId } from "slices";
import { getIsMaximized } from "slices/window-slice/index";

const VideosRow = () => {
  const dispatch = useDispatch();
  const isMaximized = useSelector(getIsMaximized);
  const videos = useSelector(selectFocusedVideos);
  const color = useSelector(getButtonBgColor);
  const selectedBadgeItem = useSelector(getSelectedBadgeVideo);
  const focusedVideo = useSelector(selectFocusedVideo);
  const selectedId = useSelector(getSelectedBadgeVideoId);

  const onClickTourItem = (idx, d) => {
    const eventHash = {
      event_name: "h_click",
      event_params: {
        h_page_type: "hayley",
        h_stream: "hyly",
        h_display_method: "iframe",
        h_clicked_location: selectedId === "pre_recorded_video" ? "recorded video" : "3d video",
        h_click_value: d.title,
        h_video_title: d.title,
        h_video_type: selectedId === "pre_recorded_video" ? "recorded video" : "3d video",
        h_view_type: selectedId === "pre_recorded_video" ? "videos" : "360 tours",
      },
    };

    window.parent.postMessage(JSON.stringify(eventHash), "*");
    dispatch(setFocusedVideoIdx(idx));
  };

  return (
    <div
      className={`!hayley-mt-4 ${
        isMaximized ? " hayley-px-2" : ""
      } hayley-hidden hayley-h-fit hayley-w-full hayley-flex-none hayley-flex-nowrap hayley-items-center hayley-gap-x-2 hayley-space-x-8 hayley-overflow-x-auto sm:hayley-flex`}
    >
      {videos.map((d, idx) => (
        <Box key={idx} className="hayley-h-fit hayley-w-fit hayley-space-y-1 sm:!hayley-mx-0">
          <Box className="hayley-relative">
            <ProgressiveImage
              classes={{ root: "hayley-h-[70px] hayley-w-[110px] sm:hayley-h-[140px] sm:hayley-w-[220px] hayley-overflow-hidden" }}
              src={d.thumbnail}
              alt={d.title}
              selectedId={selectedId}
            />

            <Box
              className={`hayley-custom hayley-absolute hayley-left-0 hayley-top-0 hayley-flex hayley-h-full hayley-w-full hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-border hayley-border-solid hayley-border-transparent ${
                focusedVideo?.thumbnail == d?.thumbnail && " hayley-border-2 !hayley-border-[#999999]"
              }`}
              sx={{ "&.hayley-custom:hover": { borderColor: `${color} !important` } }}
              onClick={() => onClickTourItem(idx, d)}
            >
              <Box className="hayley-flex hayley-h-8 hayley-w-8 hayley-items-center hayley-justify-center hayley-rounded-full hayley-bg-white/80">
                <Icon
                  iconType={selectedBadgeItem.id === "pre_recorded_video" ? "VideoPlay" : "3DTourPlay"}
                  className="hayley-h-full hayley-w-full hayley-text-secondary"
                />
              </Box>
            </Box>
          </Box>
          <div className={`hayley-truncate hayley-text-sm hayley-text-secondary ${focusedVideo?.thumbnail == d?.thumbnail && " hayley-font-semibold"}`}>
            {d.title}
          </div>
        </Box>
      ))}
    </div>
  );
};

export default VideosRow;
